// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3ALwJ","item":"PaymentsMobile_item__1j1F1","label":"PaymentsMobile_label__16Moz","amount":"PaymentsMobile_amount__Wfm_S"};